export default __webpack_public_path__ + "static/media/UpgradeGuideDoc2.9a10b79a.pdf";